import { useEffect, useState } from 'react';

/**
 * Есть ли у устройства сеть — по `navigator.onLine` и событиям браузера.
 *
 * Это знание о сетевом интерфейсе, а не о доступности бэкенда: Wi-Fi без
 * интернета даст `true`. Поэтому отсутствие сети подтверждаем ещё и по тому,
 * как завершился сам запрос (см. isNetworkError), а этот хук отвечает за
 * мгновенную реакцию — оффлайн-событие приходит раньше любого таймаута — и за
 * возврат: как только сеть появилась, можно снова спрашивать бэкенд.
 */
export const useOnlineStatus = () => {
  const [online, setOnline] = useState(
    () => typeof navigator === 'undefined' || navigator.onLine
  );

  useEffect(() => {
    const goOnline = () => setOnline(true);
    const goOffline = () => setOnline(false);

    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);

    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);

  return online;
};
